/* eslint-disable @typescript-eslint/ban-types */
import { makeApiRequestAndHandleError, simpleFetch } from 'common/utils/http';

export const fetchNewUserData = async (userIds: number[], setUserData: Function, showEnded = false) => {
  makeApiRequestAndHandleError(() => {
    if (userIds.length > 0) {
      const queryStrings = userIds
        .slice(1, userIds.length)
        .map(id => `intersectionWith=${id}`);
      if (showEnded) {
        queryStrings.push('show-ended=true');
      }

      const formattedQuery = queryStrings.join('&');
      simpleFetch(`api/v1/people/${userIds[0]}?${formattedQuery}`).then(res => setUserData(res));
    } else {
      setUserData({});
    }
  });
};

export const toggleShowAttributeStartTime = async (
  showAttributeStartTime: boolean,
  showAttributeEndTime: boolean,
  userIds: number[],
  setShowAttributeStartTime: Function,
  setShowAttributeEndTime: Function,
  setUserData: Function
) => {
  if (showAttributeStartTime) {
    if (showAttributeEndTime) {
      await fetchNewUserData(userIds, setUserData);
    }
    setShowAttributeStartTime(false);
    setShowAttributeEndTime(false);
  } else {
    setShowAttributeStartTime(true);
  }
};

export const toggleShowAttributeEndTime = async (
  showAttributeEndTime: boolean,
  userIds: number[],
  setShowAttributeStartTime: Function,
  setShowAttributeEndTime: Function,
  setUserData: Function
) => {
  if (showAttributeEndTime) {
    await fetchNewUserData(userIds, setUserData);
    setShowAttributeEndTime(false);
  } else {
    await fetchNewUserData(userIds, setUserData, true);
    setShowAttributeStartTime(true);
    setShowAttributeEndTime(true);
  }
};
